import API from '../../../constants/EnvConstants';
import callApi from "../../../utils/handleCallApi";

function* postCreateQaInformation(data) {
  const url = `${API.samuraiApiUrl}/qa_informations`;
  return yield callApi("post", url, data.data, data.accessToken, null, data.onSuccess, data.onError, data.onErrorWithNotice);
}

function* getIndexQaInformation(data) {
  const url = `${API.samuraiApiUrl}/qa_informations`;
  return yield callApi("get", url, data.data, data.accessToken, data.data, data.onSuccess, data.onError, data.onErrorWithNotice);
}

function* getShowQaInformation(data) {
  const url = `${API.samuraiApiUrl}/qa_informations/${data.data.id}`;
  return yield callApi("get", url, data.data, data.accessToken, null, data.onSuccess, data.onError, data.onErrorWithNotice);
}

function* putUpdateQaInformation(data) {
  const url = `${API.samuraiApiUrl}/qa_informations/${data.data.id}`;
  return yield callApi("put", url, data.data, data.accessToken, null, data.onSuccess, data.onError, data.onErrorWithNotice);
}

function* deleteDeleteQaInformation(data) {
  const url = `${API.samuraiApiUrl}/qa_informations/${data.data.id}`;
  return yield callApi("delete", url, data.data, data.accessToken, null, data.onSuccess, data.onError, data.onErrorWithNotice);
}

export const Api = {
  postCreateQaInformation,
  getIndexQaInformation,
  getShowQaInformation,
  putUpdateQaInformation,
  deleteDeleteQaInformation
};
